export enum CodeType { 
        PropertyStatus = 0,
        PropertyTenure = 1,
        PropertyLocation = 3,
        PropertyAgencyType = 4,
        PropertyCommissionType = 5,
        PropertyRentalTerms = 6,
        PropertyBuyingPosition = 7,
        PropertyOfferStatus = 8,
        PropertyFurnished = 9,
        ManagementTypeTypes = 10,
        PropertyBoard = 12,
        PropertyDetailsSentResponse = 13,
        PropertyRequirementAge = 14,
        PropertyWebUpload = 15,
        Currency = 16,
        PropertyPricePrefix = 17,
        AppointmentReminderInterval = 18,
        PropertyAge = 19,
        ContactType = 20,
        PropertyRetirement = 21,
        PropertyDisabledAccess = 22,
        PropertyDevelopmentPotential = 23,
        PropertyBedrooms = 24,
        DiaryView = 25,
        TaskAssignmentSnoozeInterval = 26,
        ContactReferenceResponse = 30,
        TaskPriority = 31,
        DefinableFieldType = 33,
        DepositHeld = 34,
        PropertyPriceFrequency = 35,
        ContactCategory = 36,
        ContactFurnished = 37,
        TaskStatus = 38,
        ContactParkingRequirements = 39,
        ContactGardenRequirements = 40,
        PropertyPresentationItems = 41,
        PropertyPresentationTransitionType = 42,
        ContactRentalTermsRequirements = 43,
        ServiceChargeFrequency = 44,
        ContactLandRequirements = 45,
        ContactGarageRequirements = 46,
        ContactPreparedToUpdateRequirements = 47,
        PaymentFrequency = 50,
        RoomMeasurementSuffix = 51,
        MatchContactSort = 52,
        Unknown = 53,
        PropertyFloor = 54,
        IncludeExclusiveHomes = 55,
        WorkOrderStatus = 56,
        PropertyDevelopmentStatus = 57,
        TransactionCompanyContactAccount = 58,
        TransactionDebitStatus = 59,
        TransactionCreditStatus = 60,
        PreferredDeliveryMethod = 62,
        AppointmentRecurrenceFrequency = 63,
        ContactRiversideRequirements = 64,
        ContactSeasideRequirements = 65,
        ContactLeisureFacilitiesRequirements = 66,
        TenancyStatus = 67,
        LetterType = 68,
        KeyStatus = 69,
        KeyHistoryStatus = 70,
        PreferredRentDemandMethod = 71,
        InvoiceStatus = 72,
        PropertyCategory = 73,
        ApplicantJerseyQualification = 74,
        BillStatus = 75,
        ProductTransferTo = 76,
        PropertyCentralHeating = 77,
        CompanyAccount = 78,
        Negotiator = 79,
        TenancyInterval = 80,
        Lonres = 81,
        UseClass = 82,
        PropertyJerseyQualification = 83,
        TextAlignment = 100,
        SortOrder = 101,
        NoYes = 102,
        ReferenceType = 104,
        ReferenceReportType = 105,
        LetterheadUsage = 106,
        LetterheadPages = 107,
        SyncDiary = 108,
        PropertyUsage = 109,
        PropertyDetailsSentType = 110,
        PreferredFeedbackRequestMethod = 111,
        PreferredFeedbackReportMethod = 112,
        JournalType = 113,
        PropertyFeedbackReviewAction = 114,
        RecurringFeesFrequency = 115,
        TenancyIntroductionFeeChargeFrequency = 116,
        StatementShowPropertyReference = 117,
        PropertyInvestmentPotential = 118,
        DiarySyncLevel = 119,
        WatermarkPosition = 120,
        TenantSocialStatus = 121,
        DefinableFieldControlType = 122,
        TransferStatus = 123,
        DisplaySystemMessagesOptions = 124,
        TransactionExportStatus = 125,
        CallLogType = 126,
        CallLogStatus = 127,
        SMTPAuthenicationTypes = 128,
        BankingWith = 129,
        RefundTransferFundsFrom = 130,
        LocalAuthorityLLRegistration = 131,
        WorkOrderPriority = 132,
        EventLogEventType = 133,
        MarketingEmailItemType = 134,
        MarketingEmailType = 135,
        MarketingEmailSocialMediaIconStyle = 136,
        CreateCertificate = 137,
        UnitedKingdomRegion = 138,
        HoldingDepositRefund = 139,
        MaintenanceRequestStatus = 140,
        InspectionFrequency = 141,
        CrossChargePayee = 142,
        TransactionType = 143,
        CreatePDFMethodOverride = 144,
        MailshotLetterhead = 145,
        PropertySellingMethod = 146,
        PropertyCompletionDateStatus = 147,
        PropertyFeatures = 148,
        CustodialSchemeDepositRequestStatus = 149,
        TypePropertyCategory = 150,
        CheckOutFeeContact = 151,
        TransactionDateFilter = 152,
        KeyPerformanceIndicatorComparisonType = 153,
        BalanceAction = 154,
        TenantShopContactType = 155,
        RenameMethod = 156,
        TAPIMediaMode = 157,
        SignableAccountType = 158,
        AgencyExpressBoardStatus = 159,
        AgencyExpressMovementType = 160,
        TenancyScheduleSort = 161,
        RentGuaranteeStatus = 162,
        ContentType = 163,
        MonthsOfYear = 164,
        TenantShopContactMethod = 165,
        ReturnDepositFromAccount = 166,
        ApplicantMatchingType = 167,
        InvoiceType = 168,
        SchoolPhaseOfEducation = 169,
        SchoolReligion = 170,
        SchoolTypeGroup = 171,
        ImportBankingFileFormat = 172,
        VATAccountingMethod = 174,
        ProductSalesStatus = 175,
        BackgroundProcess = 176,
        Gender = 177,
        DepositSchemes = 178,
        WebUploadType = 179,
        WebUploadStatus = 180,
        WebUploadAction = 181,
        InventorySystem = 182,
        CertificateOrderAction = 183,
        CertificateStatus = 184,
        PaymentExportFileFormat = 185,
        UploadFileType = 186,
        TheMovingHubQuoteTypes = 187,
        DeductHoldingDepositFrom = 188,
        StartupForm = 189,
        BoardManagementSystem = 190,
        RecordUpdateNotificationType = 191,
        InvoiceCategory = 192,
        BillCommissionType = 193,
        CorrespondenceViewTypeFilter = 194,
        CorrespondenceViewTaskFilter = 195,
        HomePageReminderGroups = 196,
        LegalForLandlordsServiceType = 197,
        EmailAuthenticationMethod = 198,
        OAuthIssuer = 199,
        EmailType = 200,
        EmailFormat = 201,
        HMRCExportType = 203,
        ClientPortalFileUploadType = 204,
        ImportBankingFileMatchType = 205,
        SystemConfirmationPromptMode = 206,
        AppointmentType = 207,
        FixfloAccountType = 208,
        VorensysServices = 209,
        VorensysIdentityVerified = 210,
        VorensysCitizenship = 211,
        ElectricMeterTypes = 212,
        GasMeterTypes = 213,
        FixFloManagementTypes = 214,
        WatermarkType = 215,
        RevenueIEExportType = 216,
        OverseaTaxMethod = 217,
        ElectricSupply = 218,
        WaterSupply = 219,
        DrainageSupply = 220,
        CableSupply = 221,
        GasSupply = 222,
        TelephoneSupply = 223,
        PropertyButtonSwitchType = 230,
        PropertyButtonSwitchTo = 231,
        PropertyButtonTroubleTicketStatus = 232,
        PropertyButtonSwitchBillTo = 233,
        ReportDualDetailLevel = 1000,
        ReportTriDetailLevel = 1001,
        ReportPropertyCharts = 1002,
        ReportContactCharts = 1003,
        ReportApplicantCharts = 1004,
        ReportAppointmentCharts = 1005,
        ReportProductSalesCharts = 1006,
        ReportChartType = 1007,
        ReportTenacyCharts = 1008,
        ReportAccountBalances = 1009,
        ReportAppointmentAnalysisDetailLevel = 1010,
        ReportCallLogCharts = 1011,
        ReportTaskCharts = 1012,
        ReportWorkOrderCharts = 1013,
        ReportSalesPipelineCharts = 1014,
}

